body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-repeat: no-repeat;
    color: var(--on-background, $body-font-color);
    font-family: $body-font-family;
    font-size: $font-size-base;
    line-height: 1.428571429;
    overflow-y: auto;
    text-rendering: optimizelegibility;
}
